import { Box } from '@mui/material';

import { useGetBrandColor } from 'src/hooks/hooks';

export const BrandIcon = ({
  index,
  variant = 'large',
}: {
  index: number;
  variant?: 'small' | 'large';
}) => {
  const color = useGetBrandColor(index);

  if (variant === 'small') {
    return (
      <Box
        sx={{
          bgcolor: color,
          borderRadius: '3px',
          display: 'block',
          height: '14px',
          maxWidth: '12px',
          minWidth: '12px',
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        bgcolor: color,
        borderRadius: '3px',
        display: 'block',
        height: '20px',
        maxWidth: '15px',
        minWidth: '15px',
      }}
    />
  );
};
